import { Info } from "./Info";
import { Menu } from "./Menu";
import { Newsletter } from "./Newsletter";

export const Footer = {
    Info,
    Menu,
    Newsletter,
} 